/**
 * Meta Ads Types and Constants
 *
 * Types and mappings for Meta (Facebook/Instagram) Ads API integration.
 */
// ─── Meta Ads API Configuration ─────────────────────────────────────────────
export const META_ADS_API_VERSION = 'v21.0';
export const META_ADS_API_BASE_URL = 'https://graph.facebook.com';
// ─── Meta Ads Required & Optional Scopes ────────────────────────────────────
export const META_AD_REQUIRED_SCOPES = [
    'ads_management',
    'ads_read',
    'business_management',
    'pages_read_engagement',
];
export const META_AD_OPTIONAL_SCOPES = [
    'leads_retrieval',
    'page_events',
    'read_insights',
    'instagram_basic',
    'instagram_manage_insights',
];
// ─── Account Status Mapping ─────────────────────────────────────────────────
export const META_ACCOUNT_STATUS_MAP = {
    1: 'ACTIVE',
    2: 'DISABLED',
    3: 'UNSETTLED',
    7: 'PENDING_RISK_REVIEW',
    8: 'PENDING_SETTLEMENT',
    9: 'IN_GRACE_PERIOD',
    100: 'PENDING_CLOSURE',
    101: 'CLOSED',
    201: 'ANY_ACTIVE',
    202: 'ANY_CLOSED',
};
// ─── Campaign Status Mapping ────────────────────────────────────────────────
export const META_CAMPAIGN_STATUS_MAP = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    DELETED: 'DELETED',
    ARCHIVED: 'ARCHIVED',
};
// ─── Ad Set Status Mapping ──────────────────────────────────────────────────
export const META_AD_SET_STATUS_MAP = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    DELETED: 'DELETED',
    ARCHIVED: 'ARCHIVED',
};
// ─── Ad Status Mapping ─────────────────────────────────────────────────────
export const META_AD_STATUS_MAP = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    DELETED: 'DELETED',
    ARCHIVED: 'ARCHIVED',
    DISAPPROVED: 'DISAPPROVED',
    PENDING_REVIEW: 'PENDING_REVIEW',
    PREAPPROVED: 'PREAPPROVED',
    WITH_ISSUES: 'WITH_ISSUES',
};
// ─── Ad Placement Mappings ──────────────────────────────────────────────────
export const AD_PLACEMENT_TO_META = {
    facebook_feed: 'feed',
    facebook_stories: 'story',
    facebook_reels: 'reels',
    facebook_right_column: 'right_hand_column',
    facebook_marketplace: 'marketplace',
    facebook_video_feeds: 'video_feeds',
    facebook_search: 'search',
    instagram_feed: 'stream',
    instagram_stories: 'story',
    instagram_reels: 'reels',
    instagram_explore: 'explore',
    audience_network: 'classic',
    messenger_inbox: 'messenger_home',
    messenger_stories: 'story',
};
export const META_TO_AD_PLACEMENT = Object.fromEntries(Object.entries(AD_PLACEMENT_TO_META).map(([k, v]) => [v, k]));
// ─── Ad Objective Mappings ──────────────────────────────────────────────────
export const AD_OBJECTIVE_TO_META = {
    awareness: 'OUTCOME_AWARENESS',
    traffic: 'OUTCOME_TRAFFIC',
    engagement: 'OUTCOME_ENGAGEMENT',
    leads: 'OUTCOME_LEADS',
    app_promotion: 'OUTCOME_APP_PROMOTION',
    sales: 'OUTCOME_SALES',
};
export const META_TO_AD_OBJECTIVE = Object.fromEntries(Object.entries(AD_OBJECTIVE_TO_META).map(([k, v]) => [v, k]));
// ─── Ad Bid Strategy Mappings ───────────────────────────────────────────────
export const AD_BID_STRATEGY_TO_META = {
    lowest_cost: 'LOWEST_COST_WITHOUT_CAP',
    cost_cap: 'COST_CAP',
    bid_cap: 'LOWEST_COST_WITH_BID_CAP',
    minimum_roas: 'LOWEST_COST_WITH_MIN_ROAS',
};
export const META_TO_AD_BID_STRATEGY = Object.fromEntries(Object.entries(AD_BID_STRATEGY_TO_META).map(([k, v]) => [v, k]));
// ─── CTA Types ──────────────────────────────────────────────────────────────
export const META_CTA_TYPES = [
    'APPLY_NOW',
    'BOOK_TRAVEL',
    'BUY_NOW',
    'BUY_TICKETS',
    'CALL_NOW',
    'CONTACT_US',
    'DONATE_NOW',
    'DOWNLOAD',
    'GET_DIRECTIONS',
    'GET_OFFER',
    'GET_QUOTE',
    'GET_SHOWTIMES',
    'INSTALL_APP',
    'LEARN_MORE',
    'LISTEN_NOW',
    'MESSAGE_PAGE',
    'NO_BUTTON',
    'OPEN_LINK',
    'ORDER_NOW',
    'PLAY_GAME',
    'RECORD_NOW',
    'SHOP_NOW',
    'SIGN_UP',
    'SUBSCRIBE',
    'WATCH_MORE',
    'WHATSAPP_MESSAGE',
];
// ─── Special Ad Categories ──────────────────────────────────────────────────
export const META_SPECIAL_AD_CATEGORIES = [
    'NONE',
    'EMPLOYMENT',
    'HOUSING',
    'CREDIT',
    'ISSUES_ELECTIONS_POLITICS',
    'ONLINE_GAMBLING_AND_GAMING',
];
//# sourceMappingURL=meta-ads.types.js.map